import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { Search } from "@/shared/ui/search"
import { selectSocialMarketPartnersSearchQuery, setSearchQuery } from "../../model"

export const SocialMarketPartnersFilters = () => {
    const search = useAppSelector(selectSocialMarketPartnersSearchQuery)
    const dispatch = useAppDispatch()

    return (
        <div>
            <Search
                value={search}
                onChange={(e) => dispatch(setSearchQuery(e))}
            />
        </div>
    )
}